module.exports = __webpack_public_path__ + "img/tk2.a44fb0ff.jpg";